import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApiObjectData } from '../models/api-object-data';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    appUrl = environment.baseUrl + '/';
    apiUrl = environment.baseUrl + '/api/';
    imgUrl = environment.baseUrl
    private logoutTimer: any;
    private currentUser: any;
    private appLoaderCallback?: () => void;

    constructor(
        public http: HttpClient,
        public router: Router,
        public translate: TranslateService,
    ) { }

    registerAppLoader(callback: () => void): void {
        this.appLoaderCallback = callback;
    }

    showAppLoader(): void {
        if (this.appLoaderCallback) {
            this.appLoaderCallback();
        }
    }

    get(id: number, controller: string): Observable<ApiObjectData> {
        return this.http.get<ApiObjectData>(this.apiUrl + controller + '/' + id);
    }

    getById<T>(controller: string, params?: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const encryptedTeamIds = localStorage.getItem('encryptedTeamIds') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang,
            'EncryptedTeamIds': encryptedTeamIds
        });

        const options = {
            headers: headers,
            params: params || {}
        };

        return this.http.get<T>(`${this.apiUrl}${controller}`, options);
    }




    gets<T>(controller: string): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const encryptedTeamIds = localStorage.getItem('encryptedTeamIds') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang,
            'EncryptedTeamIds': encryptedTeamIds
        });
        const options = {
            headers: headers,
        };

        return this.http.get<T>(`${this.apiUrl}${controller}/`, options);
    }

    save<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.post<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    updateWithPut<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.put<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    upload<T>(controller: string, formData: FormData, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const defaultHeaders = new HttpHeaders({
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders
        };

        return this.http.post<T>(`${this.apiUrl}${controller}`, formData, options);
    }

    update<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.put<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    saveById<T>(controller: string, id: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?id=${id}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveByParam<T>(controller: string, reservationId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?reservationId=${reservationId}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveByParamPhone<T>(controller: string, phoneNumber: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?phoneNumber=${phoneNumber}`;
        return this.http.post<T>(url, null, { headers })
    }

    verfityTheOtp<T>(controller: string, params: { [key: string]: string | number }): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        let queryString = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
        const url = `${this.apiUrl}${controller}?${queryString}`;
        return this.http.post<T>(url, null, { headers })
    }

    deleteById<T>(controller: string, id: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('id', id)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    saveBatch(controller: string, model: any) {
        return this.http.post(this.apiUrl + controller + '/', model);
    }

    remove(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + id);
    }

    posts(controller: string, id: number) {
        return this.http.post(this.apiUrl + controller + id, '');
    }

    Remove(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + '/Remove/' + id);
    }
    Removes(controller: string, id: number, excId: number, userId: number) {
        return this.http.delete(this.apiUrl + controller + id + '/' + excId + '/' + userId);
    }

    delete(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + '/delete/' + id);
    }

    removes(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + id)
    }

    post(controller: string, operation: string, model: any) {
        return this.http.post(this.apiUrl + controller + '/' + operation, model);
    }

    deletePost(controller: string, id: any) {
        return this.http.post(this.apiUrl + controller + '/' + id, {});
    }

    filePath(controller: string, filepath: string) {
        const url = `${this.apiUrl}${controller}?filePath=${encodeURIComponent(filepath)}`;
        return this.http.post(url, {});
    }

    Put(controller: string, model: any) {
        return this.http.put(this.apiUrl + controller, model)
    }

    PutMain(controller: string, id: any, model: any) {
        return this.http.put(this.apiUrl + controller + '/' + id, model);
    }

    Putmini(controller: string, id: any, userId: any) {
        return this.http.put(this.apiUrl + controller + '/' + id + '/' + userId, {});
    }

    PutPlus(controller: string, id: any, userId: any, buildingId: any) {
        return this.http.put(this.apiUrl + controller + '/' + id + '/' + userId + '/' + buildingId, {});
    }

    PutwithId(controller: string, userId: any) {
        return this.http.put(this.apiUrl + controller + '/' + userId, {});
    }

    // Method to set current user data
    setCurrentUser(user: any): void {
        this.currentUser = user;
        localStorage.setItem('currentUser', JSON.stringify(user)); // Store user in localStorage

        if (user !== null) {
            const expirationTime = new Date().getTime() + user.expireInSeconds * 1000;
            localStorage.setItem('expirationTime', expirationTime.toString());
            this.setLogoutTimer(user.expireInSeconds);
        }

    }

    setLogoutTimer(duration: number) {
        // Clear any existing timer
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
        }

        // Set a new timer
        this.logoutTimer = setTimeout(() => {
            this.autoLogout();
        }, duration * 1000); // Convert seconds to milliseconds
    }


    autoLogout() {
        // Clear the token and any user-related data
        localStorage.removeItem('currentUser');
        localStorage.removeItem('expirationTime');

        // Redirect to the login page
        this.router.navigate(['/auth/login']);

        // Clear the timer
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
        }
    }


    // Method to get current user data
    getCurrentUser(): any {
        if (!this.currentUser) {
            const user = localStorage.getItem('currentUser');
            this.currentUser = user ? JSON.parse(user) : null;
        }

        return this.currentUser;
    }
}